import React from "react";
import styled from "styled-components";
import spinner from "./spinner.svg";
const AnimationContainer = styled.div`
  min-height: 100vh;
  height: 100%;
  display: flex;
  top: 0;
  position: absolute;
  width: 100%;
  z-index: 3;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    90deg,
    rgba(41, 59, 90, 0.95) 0%,
    rgba(123, 150, 196, 0.95) 100%
  );
`;

const FilledLoading = () => {
  return (
    <AnimationContainer>
      <img src={spinner} width="350" alt="spinner" />
    </AnimationContainer>
  );
};

export default FilledLoading;
